import { createContext } from 'react';

import { UndoRedoContextType } from './types';

export const UndoRedoContext = createContext<UndoRedoContextType | undefined>(
  undefined,
);
